import { render, staticRenderFns } from "./UserDepositReg.vue?vue&type=template&id=66227602"
import script from "./UserDepositReg.vue?vue&type=script&lang=js"
export * from "./UserDepositReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports